export const SET_PAGE_SIZE = 'SET_PAGE_SIZE'
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'
export const SET_SORT_DIR = 'SET_SORT_DIR'
export const SET_ORDER_BY = 'SET_ORDER_BY'
export const SET_FILTER_OPTIONS = 'SET_FILTER_OPTIONS'
export const SET_FILTER_BY = 'SET_FILTER_BY'
export const SET_LOCATION_TREE = 'SET_LOCATION_TREE'
export const SET_NETWORK_TREE = 'SET_NETWORK_TREE'
export const SET_LOCATIONS = 'SET_LOCATIONS'
export const SET_LOCATION = 'SET_LOCATION'
export const SET_LOCATIONS_FOUND = 'SET_LOCATIONS_FOUND'
export const SET_PREFERENCES = 'SET_PREFERENCES'
export const RESET_PREFERENCES = 'RESET_PREFERENCES'
export const SET_PREFERENCE = 'SET_PREFERENCE'
export const UPDATE_PREFERENCE = 'UPDATE_PREFERENCE'
export const RESET_PREFERENCE_CHANGE = 'RESET_PREFERENCE_CHANGE'
export const PUSH_LOCATION = 'PUSH_LOCATION'
export const POP_LOCATION = 'POP_LOCATION'
export const LOCATIONS_SEARCH_TERM = 'LOCATIONS_SEARCH_TERM'
export const LOCATIONS_PAGE_SIZE = 'LOCATIONS_PAGE_SIZE'
export const LOCATIONS_SORT_DIR = 'LOCATIONS_SORT_DIR'
export const LOCATIONS_ORDER_BY = 'LOCATIONS_ORDER_BY'
export const LOCATIONS_FILTER_BY = 'LOCATIONS_FILTER_BY'
export const SET_CURRENT_LOCATION = 'SET_CURRENT_LOCATION'
export const RESET_EMAIL_TEMPLATE = 'RESET_EMAIL_TEMPLATE'
export const SET_EMAIL_TEMPLATE = 'SET_EMAIL_TEMPLATE'
export const UPDATE_EMAIL_TEMPLATE = 'UPDATE_EMAIL_TEMPLATE'
export const SET_DISPATCHED_TECHS = 'SET_DISPATCHED_TECHS'
export const SET_OUTNETWORK = 'SET_OUTNETWORK'
export const PUSH_OUTNETWORK = 'PUSH_OUTNETWORK'
export const POP_OUTNETWORK = 'POP_OUTNETWORK'
export const SET_LOCATION_FILTER = 'SET_LOCATION_FILTER'
export const SET_SHOWING_TECHS = 'SET_SHOWING_TECHS'
export const SET_SHOW_ALL_SHOPS = 'SET_SHOW_ALL_SHOPS'
export const SET_INSURANCE_FOUND = 'SET_INSURANCE_FOUND'
export const SET_INSURANCE = 'SET_INSURANCE'
export const PUSH_INSURANCE = 'PUSH_INSURANCE'
export const POP_INSURANCE = 'POP_INSURANCE'
export const SET_INSURANCE_DATA = 'SET_INSURANCE_DATA'



// WEBPACK FOOTER //
// ./src/store/modules/locations/types.js